export default __webpack_public_path__ + "af9541f0fb1d59e2139a4bfe36575c8f.png";